export default __webpack_public_path__ + "static/patient-guide--prostate-cancer-d40e425f6a465f1d0a271a0d115ca0b9.png";